export default __webpack_public_path__ + "static/brush-removal-addfcb524baf437a518c5d779b09aea4.webp";